export default {
  fine_blocking_counts: {
    title: 'Clamps by source',
    inspector: 'Inspector',
    camera: 'Camera',
    mobile_car: 'Mobile Camera Car',
    unavailable: 'Clamp counts are unavailable.'
  },
  fine_act: {
    status: 'Objection / act',
    mark_objected: 'Mark as objected',
    convert: 'Convert to act',
    download: 'Download act',
    objected: 'Objected',
    act_generated: 'Generated',
    history_act_generated: 'Act generated',
    permission: 'Allow act generation',
    template_individual: 'Act template – Individual',
    template_company: 'Act template – Legal entity',
    confirm_objection: 'Mark this administrative fine as objected?',
    confirm_generation: 'Generate and save the act using the configured template?',
    ineligible: 'Only unpaid, uncanceled fines with a generated ticket are eligible.',
    missing_template: 'Configure the appropriate individual or legal-entity act template first.',
    invalid_template: 'The act template is invalid or contains unsupported variables. Upload a valid DOCX template.',
    missing_data: 'The fine is missing data required to generate an act.',
    not_objected: 'Mark the fine as objected before generating an act.',
    already_generated: 'An act has already been generated for this fine.',
    busy: 'This fine is being processed. Try again shortly.',
    not_found: 'The fine could not be found.',
    template_read_failed: 'The template could not be loaded. Try again.',
    save_failed: 'The act could not be saved. The fine remains objected; try again.',
    download_failed: 'A download link could not be created. Try again.',
    failed: 'The action failed. Refresh the fine and try again.',
    download_retry: 'The act is saved. Download it again from the fine details.',
    administrative_only: 'Act templates are available only for administrative fine types.'
  },
  citizen_drawings: {
    title: 'Citizen map drawings',
    introduction: 'Create clear street lines and parking areas for the citizen map.',
    new_drawing: 'New citizen map drawing',
    edit_drawing: 'Edit citizen map drawing',
    zone: 'Parking zone',
    type: 'Drawing mode',
    line: 'Line / Street',
    area: 'Area / Parking',
    client_city: 'Client city',
    external_city: 'External city',
    color: 'Color',
    width: 'Width',
    opacity: 'Opacity',
    trace_street: 'Trace street',
    rectangle: 'Rectangle',
    custom_outline: 'Custom outline',
    edit_vertices: 'Edit points',
    done_editing: 'Done editing',
    clear_drawing: 'Clear drawing',
    finish: 'Finish',
    undo_point: 'Undo point',
    fit_map: 'Fit map',
    show_reference: 'Show parking boundaries',
    reference_legend: 'Dashed gray: reference only. Faint dotted: inactive areas.',
    reference_notice:
      'Parking boundaries are read-only references. Saving this drawing never changes them.',
    line_help:
      'Click points along the street, then choose Finish. Use Edit points to move or add points.',
    area_help: 'Drag a rectangle or trace a custom outline. Use Edit points to adjust the shape.',
    select_zone: 'Select a city and parking zone to open the map.',
    checking_coverage: 'Checking parking coverage…',
    coverage_title: 'Review parking coverage',
    outside_coverage:
      'This drawing extends outside the zone’s active parking boundaries. Save it anyway?',
    coverage_unavailable:
      'Parking coverage cannot be fully checked because active boundaries are missing or invalid. Save it anyway?',
    save_anyway: 'Save anyway',
    change_type_title: 'Change drawing mode?',
    change_type_message: 'Changing the drawing mode clears the current shape. Continue?',
    delete_message:
      'Delete this citizen map drawing? Existing parking boundaries will remain unchanged.',
    activate: 'Activate',
    deactivate: 'Deactivate',
    required: 'This field is required.',
    coordinates_required:
      'Draw a street with at least two points or an area with at least three points. Use no more than 2000 points.',
    load_error: 'Drawings or city options could not be loaded. Please try again.',
    context_error: 'The zone’s reference map could not be loaded. Please retry before saving.',
    validation_error: 'Coverage could not be checked. Saving will check it again.',
    save_error: 'The drawing could not be saved. Please try again.',
    retry: 'Retry',
    columns: {
      ID: 'ID',
      Name: 'Name',
      Type: 'Drawing mode',
      Status: 'Status',
      City: 'City',
      Zone: 'Parking zone',
      Color: 'Color'
    }
  },
  country_admin: {
    cities: 'External cities',
    zones: 'External parking zones',
    forbidden: 'Only Super Admin users can manage external cities and parking zones.',
    hourly_price: 'Hourly parking price',
    sms_number: 'SMS number',
    currency: 'Currency (ISO code)',
    price_bgn: 'Display price in BGN',
    english_name: 'English name',
    areas: 'Parking areas and boundaries',
    new_area: 'New parking area',
    delete_city: 'Remove this external city and all its parking zones and areas?',
    delete_zone: 'Remove this parking zone and all its areas?'
  },
  printerBlocks: {
    category: 'Static Printer Text',
    blockType: 'Block type',
    fixedContent:
      'Fixed text and printer formatting only. Variables are not supported. One header and one footer per city; the key is assigned automatically.'
  },
  blocking_request_history: {
    title: 'Blocking Request History',
    forbidden: 'You do not have permission to view blocking request history.',
    retry: 'Retry',
    limit: 'Up to 100 vehicles, sorted by the selected column.',
    loading: 'Loading blocking request history…',
    error: 'Blocking request history could not be loaded. Please try again.',
    select_status: 'Select at least one request status.',
    breakdown: 'Cancellation breakdown',
    users: 'Users',
    no_user: 'No user recorded',
    columns: {
      License: 'License plate',
      ExpiredRequests: 'Expired requests',
      CancelledByInspector: 'Cancelled by inspector',
      CancelledByTyreBlocker: 'Cancelled by tyre blocker',
      CancelledByRepatriator: 'Cancelled by repatriator',
      CancelledByAdmin: 'Cancelled by admin',
      CancelledBySystem: 'Cancelled by system',
      CancelledByUnknown: 'Cancelled by unknown',
      CancelledRequests: 'Total cancelled',
      TotalDeclinedRequests: 'Total declined requests',
      FineImposed: 'Fine imposed',
      NumberOfFines: 'Number of fines',
      Status: 'Status',
      CreatedAt: 'Date'
    },
    options: {
      block_request_expired: 'Block request expired',
      canceled_tyre_block: 'Block request cancelled',
      all: 'All',
      yes: 'Yes',
      no: 'No'
    }
  },
  fine_inspections: {
    title: 'Vehicle inspections on the fine date',
    order_info: 'Sorted from newest to oldest, up to 100 inspections.',
    date_time: 'Date and time',
    result: 'Parking result',
    moderation: 'Inspection status',
    moderation_info:
      'Shows whether the inspection was accepted, is awaiting review, or was rejected. The parking result is shown separately.',
    position: 'Position',
    incident: 'Incident',
    no_incident: 'No incident',
    fine_inspection: 'Inspection for this fine',
    allowed: 'Parking allowed',
    not_allowed: 'Parking not allowed',
    not_checked: 'Not checked',
    empty: 'No inspections for this vehicle on the fine date.',
    sources: {
      app_manual: 'Manually entered license plate',
      app_ocr: 'Plate check with photo',
      camera: 'Fixed camera',
      mobile_camera: 'Mobile camera',
      camera_manual: 'Camera - manual check',
      admin_panel_repatriation_request: 'Tow request from admin panel',
      other: 'Other source'
    },
    statuses: {
      pending: 'Awaiting review',
      confirmed: 'Inspection accepted',
      auto_confirmed: 'Automatically accepted',
      confirmed_edited: 'Accepted after plate correction',
      rejected: 'Inspection rejected',
      auto_rejected: 'Automatically rejected',
      expired: 'Review time expired'
    },
    types: {
      disabled_parking_spot: 'Accessible parking space'
    }
  },
  subscription_logs: {
    unknown_user: 'User not recorded',
    actions: {
      Created: 'Created',
      Updated: 'Updated',
      StatusChanged: 'Status changed',
      Added: 'Added',
      Removed: 'Removed'
    },
    entities: {
      ParkingZone: 'Parking zone',
      ParkingArea: 'Parking area',
      Vehicle: 'Vehicle'
    }
  },
  subscription_log: {
    changed_by: 'Changed by',
    system: 'System',
    unknown: 'Unknown',
    field: 'Field',
    all: 'All',
    selected: 'Selected',
    zones: 'Parking zones',
    areas: 'Parking areas',
    Subscription: 'Subscription',
    ParkingZone: 'Parking zone',
    ParkingArea: 'Parking area',
    Vehicle: 'Vehicle',
    Added: 'Added',
    Removed: 'Removed',
    Updated: 'Updated',
    Created: 'Created',
    StatusChanged: 'Status changed'
  },
  whitelist_car: {
    active_vehicles: 'Active vehicles: {current} / {limit}'
  },
  whitelist_paid_parking: {
    end_time_hint: 'Only end times covered by the configured cards and tickets are available.',
    end_date: 'End date',
    end_time: 'End time',
    buy_all: 'Buy all',
    no_daily_card:
      'No suitable combination of cards and tickets was found. Try a different period.',
    already_covered: 'This range is already covered or requires no paid parking.',
    card_count: '{count} parking item | {count} parking items',
    range_success: 'Bought {count} parking items for {amount} {currency}.',

    title: 'Purchase ticket or daily card',
    type: 'Type',
    ticket: 'Ticket',
    daily_card: 'Daily card',
    zone: 'Parking zone',
    duration: 'Duration',
    start_date: 'Start date',
    start_time: 'Start time',
    amount: 'Calculated amount',
    buy: 'Buy',
    close: 'Close',
    today: 'Leave empty to use today in the city’s time zone.',
    now: 'Default start time',
    limit_reached: 'You have reached the maximum number of active vehicles exempt from payment.',
    link: 'Purchase a daily card or ticket here',
    setting: 'Allow paid parking sales from Admin Panel when exempt-vehicle limit is reached',
    configuration_error:
      'The paid parking could not be registered. Check your access and parking configuration, then try again.',
    success_details:
      'Paid parking was successfully registered. Type: {type}; Registration number: {license}; Zone: {zone}; Valid from: {start} to {end}; Duration: {duration} minutes; Amount: {amount} {currency}.'
  },
  whitelist_expiration: {
    time: 'Expiration time',
    helper: 'If no time is entered, the exemption remains valid until the end of the selected day.',
    end_of_day: 'End of day',
    invalid: 'Select a valid expiration date and time.'
  },
  whitelist_bulk: {
    selected: '{count} selected',
    clear: 'Clear selection',
    actions: 'Bulk Actions',
    apply: 'Apply',
    activate: 'Activate',
    deactivate: 'Deactivate',
    expiration: 'Change expiration',
    forever: 'Set as Forever',
    delete: 'Delete',
    confirm_title: 'Change {count} selected vehicles?',
    confirm_activate: 'The selected vehicles will be changed to Active.',
    confirm_deactivate: 'The selected vehicles will be changed to Inactive.',
    confirm_expiration:
      'The expiration date of the selected vehicles will be set to {date}. Vehicles with a future expiration will be activated.',
    confirm_forever: 'The selected vehicles will be set as Forever and activated.',
    confirm_delete: 'The selected vehicle records will be deleted.',
    error: 'The bulk action could not be completed. Please try again.'
  },
  camera_notes: {
    title: 'Notes',
    note: 'Note',
    add: 'Add note',
    edit: 'Edit note',
    remove: 'Remove note',
    saved: 'Note saved.',
    updated: 'Note updated.',
    removed: 'Note removed.',
    validation: 'Enter a note between 1 and 500 characters.',
    save_error: 'Could not save the note. Please try again.',
    remove_error: 'Could not remove the note. Please try again.'
  },
  validation: {
    allowed_file_extensions: 'Supported file types: {extensions}',
    file_upload_failed: 'File upload failed. Please try again.',
    AddressSlots:
      'No address has been saved. ' +
      'If you have entered the details, please make sure to press the green "Add Address" button to register it.',
    alreadyExists: '{0} {1} already exists', // example with placeholders. Don't remove yet
    signup_failed: 'Sign up failed',
    required: 'This field is required',
    email: 'Please enter a valid email format',
    numeric: 'Must be a numeric value',
    minLengthOf: 'Minimum length is {0}',
    maxLengthOf: 'Maximum length is {0}',
    minValue: 'Minimum value is ',
    maxValue: 'Maximum value is ',
    repeatPassword: 'Password does not match',
    notValidRange: 'Value is outside of range',
    alpha: 'Must be a alphabetic value',
    invalid_credentials: 'Invalid credentials',
    strongPassword: 'Must have at least 8 characters with one number and one uppercase letter',
    not_properly_formatted: 'Field is not properly formatted.',
    invalid_phone_number: 'Invalid phone number',
    password_is_weak:
      'Must have at least 8 characters with one uppercase letter and a special character',
    password_hint: 'Must have at least 8 characters with one number and one uppercase letter',
    namesMinLength: 'Names must have more than one letter',
    required_field: 'This field is required',
    invalid_country_code: 'Invalid country code',
    internal_server_error: 'Oops, something went wrong',
    valid_phone_number: 'Must be a valid phone number like 359800000000',
    Prices: 'At least one price is required',
    CarSlots: 'At least one car slot is required',
    Borders: 'Please draw area borders',
    no_location: 'Please select an address from the list of suggestions',
    no_result: 'No results',
    cars_cannot_be_more_than: 'Cars cannot be more than ',
    active_cars_cannot_be_more_than: 'Active cars cannot be more than ',
    addresses_cannot_be_more_than: 'Addresses cannot be more than ',
    active_addresses_cannot_be_more_than: 'Active addresses cannot be more than ',
    first_select: 'Please first select',
    invalid_camera_side: 'Camera side must be left, right or both',
    apk_file: 'File must be an APK'
  },
  menu: {
    citizen_map_drawings: 'Citizen map drawings',
    external_cities: 'External cities',
    super_statistics: 'Super statistics',
    external_park_zones: 'External parking zones',
    blocking_request_history: 'Blocking Request History',
    postPay: 'Post pay',
    car_info: 'Car Info',
    notifications: 'Известия',
    traffic_monitoring: 'Traffic Monitoring',
    mobile_camera_tracker: 'Mobile Camera',
    mobile_camera_activity: 'Mobile cameras FPS',
    employees_report: 'Employee report',
    monthly_statistics: 'Monthly (summary)',
    monthly_employees_statistics: 'Monthly (employees)',
    comments: 'Comments',
    street: 'Streets',
    city_payment_provider: 'City payment providers',
    payment_report: 'Monthly Payments Report',
    tickets_and_cards: 'Tickets & cards',
    users: 'Users',
    citizens: 'Citizens',
    employees: 'Employees',
    cameras: 'Cameras',
    trade_network: 'Trade network',
    statistics: 'Statistics',
    settings: 'Settings',
    general_settings: 'General settings',
    cities: 'Cities',
    company: 'Company',
    store: 'Store',
    store_statistics_by_zone: 'Store statistics (by zone)',
    fine_type: 'Fine type',
    discount: 'Subscriptions discount',
    whitelist_car: 'Whitelist car',
    car_tolorance: 'Service vehicles',
    paytrix_config: 'Paytrix config',
    paytrix_print_config: 'Paytrix print config',
    subscription: 'Subscription',
    subscriptions: 'Subscriptions',
    business_subscriptions: 'Business Subscriptions',
    delete_subscription: 'Delete Subscription',
    deleted_subscriptions: 'Deleted Subscriptions',
    deleted_business_subscriptions: 'Deleted Business Subscriptions',
    subscription_plan: 'Subscription plan',
    subscription_lookup: 'Subscription Lookup',
    roles_and_permissions: 'Roles & Permissions',
    admin_notifications: 'Admin notifications',
    user_management: 'User management',
    park_zone: 'Park zone',
    park_area: 'Park area',
    mc_park_area: 'Mobile Camera Park area',
    payment_statistics: 'Payments',
    administrative_fine_statistics: 'Administrative fine statistics',
    translations: 'Translations',
    translations_city: 'For cities',
    translations_common: 'Common',
    resources: 'Resources',
    permissions: 'Permissions',
    daily_card: 'Daily cards',
    tickets: 'Tickets',
    sms: 'SMS',
    non_working_days: 'Non-working days',
    incidents: 'Incidents',
    active_incidents: 'Active incidents',
    past_incidents: 'Past incidents',
    finished_incidents: 'Finished incidents',
    fine: 'Fines',
    mvr_fines: 'MVR Fines',
    fines: 'Fines',
    payments: 'Payments',
    reports: 'Reports',
    repatriator_activity: 'Repatriator activity',
    inspector_activity: 'Inspector activity',
    tyreblocker_activity: 'Tyreblocker activity',
    employees_statistics: 'Employees Statistics',
    camera_activity: 'Camera activity',
    parking: 'Parking',
    repatriation_incidents: 'Repatriation',
    camera_inspections: 'Camera Inspections',
    inspection_reviews: 'Inspection Reviews',
    inspections: 'Inspections',
    mobile_camera: 'Mobile Cameras',
    mobile_camera_dashboard: 'Mobile Cameras Dashboard',
    mobile_apps: 'Mobile Apps'
  },
  dashboard: {
    plate_confirmation_statistics_mobile: 'Plate confirmation statistics (Mobile cameras)',
    plate_confirmation_statistics_static: 'Plate confirmation statistics (Static cameras)',
    confirmed_without_correction_tooltip:
      'Inspections where the license plate was confirmed without changing the originally recognized plate number.',
    confirmed_with_correction_tooltip:
      'Inspections where the originally recognized license plate number was corrected before confirmation.',
    taken_block_requests: 'Clamp requests taken',
    static_cameras_working: 'Static cameras',
    inspectors_working: 'Working inspectors',
    total_rejection_reasons: 'Total Rejection Reasons',
    plate_confirmation_statistics: 'Plate Confirmation Statistics',
    confirmed_without_correction: 'Confirmed without correction',
    confirmed_with_correction: 'Confirmed with correction',
    total_inspections_tooltip:
      'All inspections created during the selected day. The same vehicle may be inspected more than once.',
    valid_inspections_tooltip: 'Number of checks on vehicles with an active parking payment.',
    block_requests_tooltip: 'Number of license plates for which a clamp request was created.',
    taken_block_requests_tooltip: 'Clamp requests taken by an employee.',
    blocked_tooltip: 'Number of vehicles that currently have a wheel clamp.',
    static_cameras_working_tooltip:
      'Active static cameras with at least one check on the selected day, out of all active static cameras.',
    inspectors_working_tooltip:
      'Active inspectors who are allowed to perform checks and have made at least one check today, out of all active inspectors with this access.',
    live_statistics: 'Live statistics',
    dashboard_overview: 'Dashboard Overview',
    summary_for_today: 'Summary for Today',
    camera_performance: 'Camera performance today',
    overview_inspection_performance: 'Overall Check Effectiveness',
    last_updated: 'Last updated',
    not_loaded: 'Not loaded',
    load_error: 'Could not load dashboard data.',
    scope_city: 'City',
    scope_all_cities: 'All cities',
    total_scope: '(Total)',
    mobile_car: 'Mobile Cameras',
    static_cameras: 'Static Cameras',
    inspectors: 'Inspectors',
    total_inspections: 'Total inspections',
    inspections: 'inspections',
    valid_inspections: 'Valid checks',
    block_requests: 'Clamp requests',
    blocked: 'Clamped',
    efficiency: 'Efficiency',
    efficiency_index: 'Efficiency Index',
    efficiency_high: 'High',
    efficiency_medium: 'Medium',
    efficiency_low: 'Low',
    no_rejection_reasons: 'No rejection reasons today',
    mobile_rejection_reasons: 'Rejection reasons (Mobile Cameras)',
    static_rejection_reasons: 'Rejection reasons (Static Cameras)',
    reason_accessible_parking_slot: 'Accessible parking space',
    reason_incomplete_invisible_number: 'Invalid/Incorrect number',
    reason_paid_parking_space: 'Paid parking space',
    reason_outside_zone: 'Outside of zone',
    reason_car_with_special_status: 'Car with special status',
    reason_moving_car: 'Moving car'
  },
  mvr_fines: {
    globe_number: 'Globe number',
    vehicle_registration_number: 'Vehicle registration number',
    payment_status: 'Payment status',
    data_for_period: 'Data for period',
    export_all_filtered_results: 'Export all filtered results',
    selected_all_filtered_results: 'Selected: all filtered results',
    selected_count: 'Selected: {0}',
    export_to_mvr: 'Export to MVR',
    choose_export_method: 'Choose an export method for the selected fines:',
    single_document: 'Single Document',
    limit_records_per_document: 'Limit records per document',
    max_records_per_document: 'Max records per document',
    notification: 'Notification',
    fine: 'Fine',
    ticket_number: 'Ticket Number',
    personal_id: 'EGN',
    first_name: 'First Name',
    middle_name: 'Middle Name',
    last_name: 'Last Name',
    date_time: 'Date/Time',
    created_by: 'Created By',
    photos: 'Photos',
    fid: 'FID',
    inspector_rejected_request: 'Inspector who rejected the request',
    inspector_paid_to_name: 'Inspector PaidTo Name',
    globe_type: 'Globe type',
    administrative_type: 'Administrative type',
    administrative_ticket_status: 'Administrative ticket status',
    registration_number: 'Reg. Number',
    canceled_on: 'Canceled on',
    created_on: 'Created on',
    order_id: 'Order ID',
    paid: 'Paid',
    unpaid: 'Unpaid',
    cancelled: 'Cancelled',
    sent_to_mvr: 'Sent to MVR',
    invoice_generated: 'Invoice generated',
    sent_to_notary: 'Sent to notary',
    generated: 'Generated',
    today: 'Today',
    five_days: '5 days',
    eight_days: '8 days',
    custom_period: 'Custom Period'
  },
  mobileCameraMap: {
    hideInspections: 'Hide inspections',
    hideCar: 'Hide car',
    showParkAreas: 'Show park areas',
    largerMap: 'Larger map',
    showCarLocation: 'Show car location',
    googleMap: 'Google Map',
    lastUpdate: 'Last update',
    editingArea: 'Editing area',
    savingArea: 'Saving...',
    outsideParkAreaWarning:
      'This area extends outside the normal park area. Saving is still allowed.'
  },
  btn: {
    download_document: 'Download Document',
    add_document_template: 'Add Template',
    page_info: 'Page Info',
    stop: 'Stop',
    show_car_info: 'Show car info',
    search: 'Search',
    undo_finalize: 'Undo Finalize',
    download_qrcode: 'Download QRCode',
    finalize: 'Finalize',
    unassign_release_car: 'Unassign Release Car',
    return_request: 'Return request',
    unblock_no_payment: 'Unblock With No payment',
    mark_as_trusted: 'Mark as trusted',
    mark_as_not_trusted: 'Mark as not trusted',
    cameras: 'Cameras',
    detections: 'Detections',
    statistics: 'Statistics',
    mobile_camera_logs: 'Mobile camera logs',
    yes: 'Yes',
    no: 'No',
    mark_as_paid: 'Mark as paid',
    release_car: 'Release car',
    print: 'Print',
    print_table: 'Print table',
    print_images: 'Print images',
    print_combined: 'Print all',
    cancel_fine: 'Cancel fine',
    preview_incident: 'Preview incident',
    export: 'Export',
    profile: 'Profile',
    change_password: 'Change password',
    logout: 'Logout',
    clear_all_cache: 'Clear All Caches',
    re_init_rbac: 'Re-init RBAC',
    login: 'Login',
    forgotten_password: 'Forgot password',
    submit: 'Submit',
    create: 'Create',
    go_to_users: 'Go to users',
    go_to_subscription_plans: 'Go to subscription plans',
    cancel: 'Cancel',
    decline_request: 'Decline Request',
    close: 'Close',
    back: 'Back',
    refresh: 'Refresh',
    update: 'Update',
    change_settings: 'Change settings',
    preview: 'Preview',
    update_license: 'Update license',
    remove: 'Remove',
    clear: 'Clear',
    actions: 'Actions',
    copy: 'Copy',
    get_access_token: 'Get access token',
    approve: 'Approve',
    pay: 'Pay',
    reverse_pay: 'Reverse payment',
    pay_with_cash: 'Pay with cash',
    pay_with_wire: 'Pay with wire',
    pay_with_bank_transfer: 'Pay with bank transfer',
    cancel_payment: 'Cancel payment',
    payments: 'Payments',
    cancelSubscription: 'Cancel subscription',
    details: 'Details',
    logs: 'Logs',
    assign_hourly_prices: 'Assign hourly prices',
    assign_daily_prices: 'Assign daily prices',
    add_new_price: 'add new price',
    add_new_duration: 'Add duration',
    reverse_cancel: 'Reverse cancel',
    change_license: 'Change license',
    release_request: 'Create release request',
    no_available_actions: 'No available actions',
    view_subscription: 'View details',
    add_another: 'Add another',
    add_car: 'Add car',
    add_address: 'Add address',
    add_price: 'Add price',
    check_address: 'Check Address',
    migrate_to_new_address_structure: 'Migrate to new address structure',
    view_all: 'View all',
    confirm: 'Confirm',
    reject: 'Reject',
    save: 'Save',
    check: 'Check',
    select: 'Select',
    add_missing_car: 'Add missing or undetected car',
    images: 'images',
    load: 'Load',
    load_defaults: 'Load defaults',
    revert: 'Revert',
    accessible_parking_slot: 'Accessible parking slot',
    paid_parking_space: 'Paid parking space',
    outside_zone: 'Outside of zone',
    invalid_incorrect_number: 'Invalid/Incorrect number',
    car_with_special_status: 'Car with special status',
    moving_car: 'Moving car',
    rejected: 'Reject',
    go_to_incident: 'Go to incident'
  },
  filter: {
    CityID: 'City',
    ID: 'ID',
    FID: 'FID',
    TicketID: 'Ticket ID',
    License: 'License plate',
    FullName: 'Full name',
    SubscriptionPlanID: 'Subscription plan',
    ParkAreaID: 'Parking area',
    ParkingLotID: 'Parking lot',
    ParkZoneID: 'Parking zone',
    Phone: 'Phone',
    Address: 'Address',
    PersonalID: 'Personal ID',
    Status: 'Status',
    FineTypeID: 'Fine type',
    FineType: 'Fine category',
    AdministrativeType: 'Document type',
    AdminUserID: 'User',
    PaidToAdminUserID: 'Payment user',
    Converted: 'Clamp converted to repatriation',
    PaymentMethod: 'Payment method',
    PaymentProviderMethod: 'Payment method',
    PaymentCode: 'Payment provider',
    TicketNumber: 'Ticket number',
    StoreID: 'Store',
    Name: 'Name',
    CameraID: 'Camera ID',
    Trusted: 'Trusted',
    Year: 'Year',
    Month: 'Month',
    Type: 'Type',
    AddressFormat: 'Address format',
    CreatedAtFrom: 'Created from',
    CreatedAtTo: 'Created to',
    DateFrom: 'Date from',
    DateTo: 'Date to',
    IssuedDateFrom: 'Issue date from',
    IssuedDateTo: 'Issue date to',
    StartDateFrom: 'Start date from',
    StartDateTo: 'Start date to',
    EndDateFrom: 'End date from',
    EndDateTo: 'End date to'
  },
  form: {
    blocking_request_history: 'Blocking Request History',
    dashboard: 'Dashboard',
    administrative_fine_statistics: 'Administrative Fine Statistics',
    subscription_document_templates: 'Subscription Document Templates',
    subscription_document_templates_info:
      'Upload a municipality document template and select the subscription statuses for which it should be generated.',
    subscription_document_statuses: 'Subscription Status',
    TicketEditMinutes: 'Ticket edit minutes',
    DailyCardEditMinutes: 'Daily card edit minutes',
    TicketViewMinutes: 'Ticket list view window (minutes, optional)',
    DailyCardViewMinutes: 'Daily card list view window (minutes, optional)',
    cancelOldIncidents: 'Cancel old incidents',
    ShowEuroPricesContext: 'Show Euro Prices Context',
    showRecentlyExpiredSubscriptionInEmployeeApp: 'Show Recently Expired Subscription in Employee App',
    freeEVParking: 'Free EV parking',
    payTyreblockOnRepo: 'Pay tyreblock on repo',
    showParkingsBeforeBlock: 'Show parking payment warnings before block',
    allowLicenseFineSearch: 'Allow fine search by license plate',
    newCitizenDailyCard: 'Enable citizen daily card shortcut',
    excludeNeighborhoodInFormattedAddress: 'Exclude neighborhood from formatted address',
    PeriodType: 'Period Type',
    current_states: 'Current state',
    histories: 'Histories',
    PayAtOnce: 'Pay At Once',
    Year: 'Year',
    data_type: 'Data type',
    data_type_mobile_camera: 'Mobile camera',
    parking: 'Parking',
    area: 'Area',
    all: 'All',
    parking_lot: 'Parking lot',
    year: 'Year',
    DisableNotifications: 'Disable Notifications',
    pay_at_once_warning: 'You must select all rows using the first checkbox.',
    DisabledTolerance: 'Disabled tolerance',
    MobileRecheckMinutes: 'Mobile camera recheck interval (minutes)',
    MobileRecheckMinutesHint:
      'Minimum time between unpaid mobile camera checks. Set 0 to disable this rule.',
    send_to_mateus: 'Send to Mateus',
    resend_to_mateus: 'Resend to Mateus',
    ReportIsFinalized: 'Report is finalized you cannot change the rows now',
    Enabled: 'Enabled',
    native_text_font_size: 'Native text font size',
    native_text_line_height: 'Native text line height',
    native_text_width_scale: 'Native text width scale',
    PaymentReport: 'Payment Report',
    NewAmount: 'New Amount',
    cannot_modify_address_slots:
      'You cannot add or modify address slots after the subscription is approved',
    select_payment_method: 'Select your payment method',
    change_license: 'Change fine license',
    template: 'Template',
    template_company: 'Company Template',
    mvr_export_template: 'MVR export template',
    mvr_invoice_template: 'MVR invoice template',
    BusinessSubscriptionNotifications: 'Business Subscription Notifications',
    WhitelistedCars: 'Whitelisted Cars',
    WhitelistCarVehicleLimit: 'Vehicle Limit',
    WhitelistCarParkZoneID: 'Parking Zone',
    WhitelistCarParkAreaID: 'Parking Area',
    tooltip_user_whitelist_settings:
      'Configure how many active vehicles this user can add to Whitelisted Cars and restrict the parking zone/area they are allowed to use.',
    whitelist_location_locked_info:
      'The configured parking zone/area is set in your user profile and cannot be changed.',
    print_document: 'Print document',
    print_help_text:
      'Scroll down this dialog to the bottom (1), click the icon next to the percentage bar, select "Отпечатване в PDF" (Print to PDF) from the menu (2), then click Отвори PDF',
    how_to_print: 'How to print',
    generate_pdf: 'Generate Document',
    download_pdf: 'Download PDF',
    mark_as_sent: 'Mark as sent',
    mark_as_received: 'Mark as received',
    mark_as_not_received: 'Mark as not received',
    upload_images: 'Upload images',
    resend: 'Resend',
    addresses: ' addresses',
    addressSlots: 'Address Slots',
    received_second_try: 'Received on second try',
    not_received_second_try: 'Not received on second try',
    notification: 'Notification',
    ticket: 'Ticket',
    download: 'Download',
    camera_actions_hint: 'Select cameras to perform actions',
    user_icon: 'Inspector',
    cancelled_icon: 'Cancel location',
    AccessibleParkingSpots: 'Accessible Parking Spots',
    PaidParkingSpots: 'Paid Parking Spots',
    CameraSide: 'Camera Side',
    map_overlay_title: 'Map reference layers',
    map_overlay_tooltip:
      'Other areas in the city as map guides. Use zone and area checkboxes to show or hide them. For mobile camera areas, nearby zone outlines from the server also hide when every reference layer is off; drawing limits still apply.',
    map_overlay_zone_toggle_all: 'Show or hide all map overlays for this zone',
    map_overlay_zone_mobile: 'All mobile camera areas in this zone',
    map_overlay_zone_normal: 'All normal areas in this zone',
    map_overlay_areas_in_zone: 'Individual areas',
    map_overlay_pick_color: 'Pick overlay color',
    map_overlay_reset_normal_color: 'Reset normal area color to zone default',
    map_overlay_hide_on_map: 'Hide on map',
    map_overlay_hide_this_area: 'Hide this area',
    map_overlay_hide_all_in_zone: 'Hide all areas in this zone',
    map_overlay_popup_zone: 'Zone:',
    map_overlay_popup_type_mobile: 'Mobile camera area',
    map_overlay_popup_type_normal: 'Normal area',
    map_overlay_popup_type_normal_sub: 'Normal sub-area',
    DriverFirstName: 'Driver first name',
    DriverLastName: 'Driver last name',
    TrustedTyreBlocker: 'Trusted Tyreblocker',
    CreateFinePrinterTextID: 'Create fine printer text',
    ReleaseCarPrinterTextID: 'Release car printer text',
    Forever: 'Forever',
    Converted: 'Converted fine',
    FullName: 'Full name',
    Variables: 'Variables',
    Text: 'Text',
    Lang: 'Language',
    Active: 'Active',
    Inactive: 'Inactive',
    fine: 'fine',
    Source: 'Source',
    ID: 'ID',
    tyreblocker_activity: 'tyreblocker activity',
    payment_fine: 'payment fine',
    payment_parking: 'payment parking',
    cancel_parkings: 'cancel parkings',
    cancel_parking: 'cancel parking',
    employee_app_inspection: 'employee app inspection',
    employee_app_fine: 'employee app fine',
    sms: 'sms',
    incident: 'Incident',
    payment_subscription: 'payment subscription',
    employee_app_tyre_block: 'employee app tyre block',
    inspector_activity: 'inspector activity',
    FromPhone: 'From phone',
    ParkZones: 'Park Zones',
    ToPhone: 'To phone',
    preview: 'Preview',
    city: 'city',
    translation: 'translation',
    company: 'company',
    store: 'store',
    fine_type: 'fine type',
    discount: 'discount',
    whitelist_car: 'whitelist car',
    car_tolorance: 'service vehicles',
    paytrix_config: 'Paytrix config',
    paytrix_print_config: 'Paytrix print config',
    subscription_plan: 'subscription plan',
    subscription: 'subscription',
    role: 'role',
    resource: 'resource',
    permission: 'permission',
    admin_user: 'Admin User',
    mobile_apps: 'Mobile Apps',
    park_zone: 'park zone',
    park_area: 'park area',
    payment_statistic: 'payment statistic',
    tickets: 'tickets',
    daily_card: 'daily card',
    non_working_days: 'non working days',
    SubscriptionDocuments: 'Subscription documents',
    SubscriptionPayments: 'Subscription payments',
    SubscriptionDocumentsAPI: 'Subscription documents API',
    create: 'Create',
    edit: 'Edit',
    Email: 'Email',
    Password: 'Password',
    Name: 'Name',
    AppType: 'App type',
    AppVersion: 'App version',
    Changes: 'Changes',
    APK: 'APK file',
    Tolerance: 'Tolerance',
    TyreBlockRequestExpirationInMinutes: 'Tyre-blocking request expiration (minutes)',
    RepatriationAfterTyreBlockInMinutes: 'Repatration after (min)',
    ExpireParkingReminderAfterInMinutes: 'Expiration reminder (min)',
    Status: 'Status',
    SMSProviderMobicaSettings: {
      Username: 'Mobica username',
      Password: 'Mobica password'
    },
    TimeZoneID: 'Time zone',
    DefaultLanguage: 'Default language',
    CountryID: 'Country',
    HasSubscriptions: 'Subscriptions',
    HasDailyCards: 'Daily cards',
    PaymentProviderIDs: 'Payment providers',
    SMSProviderID: 'SMS provider',
    SMSProviderLinkMobilitySettings: {
      Shortcode: 'Shortcode',
      Service: 'Service',
      Secret: 'Secret',
      Key: 'Key'
    },
    CityID: 'City',
    Resource: 'Resource',
    ResourceID: 'Resource',
    PaymentProviderID: 'Payment provider',
    APIKey: 'API key',
    APISecret: 'API secret',
    Service: 'Service',
    Section: 'Section',
    ItemText: 'Item text',
    ItemTextID: 'Item text',
    SecondItemText: 'Second item text',
    SecondItemTextID: 'Second item text',
    PaytrixCityID: 'Paytrix city ID',
    PaytrixService: 'Paytrix service',
    Address: 'Address',
    AddressFormat: 'Address format',
    AddressStreetType: 'Address type',
    AddressStreetID: 'Street',
    AddressStreetName: 'Street',
    AddressNumber: 'Number',
    AddressEntrance: 'Entrance',
    AddressApartment: 'Apartment',
    Subscriptions: 'Subscriptions',
    raw: 'Raw',
    structured_v1: 'Structured',
    street: 'St.',
    boulevard: 'Blvd.',
    square: 'Sq.',
    OwnerName: 'Owner name',
    MOL: 'MOL',
    Phone: 'Phone',
    VAT: 'VAT',
    SellerCompanyID: 'Seller company',
    PostalCode: 'Postal code',
    ContactPerson: 'Contact person',
    Manager: 'Manager',
    FineType: 'Fine type',
    GratisHours: 'Gratis hours',
    Price: 'Price',
    PriceDiscount: 'Price discount',
    PriceDiscountEnabled: 'Enable discount for price',
    PriceForTyreBlock: 'Price for tyre block per hour',
    PriceStayingAtParking: 'Price for staying at parking',
    PriceStayingAtParkingType: 'Price for staying at parking type',
    RequiresPhotos: 'Requires photos',
    RequiresComment: 'Requires comment',
    CanBeCreatedBeforeBlock: 'Can be created before block',
    FreeDailyParking: 'Free daily parking',
    NumberOfPayments: 'Number of payments',
    Type: 'Type',
    DiscountPrice: 'Discount price',
    DiscountPercentage: 'Discount percentage',
    License: 'License',
    ExpireAt: 'Expires at',
    IsExpired: 'Expired',
    CreatedByAdminUser: 'Created by',
    UpdatedByAdminUser: 'Updated by',
    Reason: 'Reason',
    Note: 'Note',
    SubscriptionPlanID: 'Subscription plan',
    FirstName: 'First name',
    MiddleName: 'Middle name',
    LastName: 'Last name',
    PersonalID: 'Personal ID',
    CompanyID: 'Company ID',
    CompanyName: 'Company name',
    UserAddress: 'Address',
    ParkAreaIDs: 'Park area',
    ParkZoneIDs: 'Park zone',
    SelectAll: 'Select all',
    CompanyAddress: 'Company address',
    StartDate: 'Start date',
    EndDate: 'End date',
    HideInStatistics: 'Hide in statistics',
    SubscriptionPlanPriceID: 'Subscription plan price',
    IsActive: 'Active',
    SubmissionNumber: 'Submission number',
    ThirdPartyID: 'Third party',
    Duration: 'Duration (months)',
    DurationMinutes: 'Duration (minutes)',
    DurationDays: 'Duration (days)',
    CarSlotType: 'Car slot type',
    MaxAllowedCarSlots: 'Max allowed rows',
    MaxAllowedActiveCarSlots: 'Max allowed active rows',
    PriceName: 'Price name',
    PriceNoVAT: 'Price (no VAT)',
    PriceProviderChargingCode: 'Provider charging code',
    ExpireSubscriptionReminderInMinutes: 'Expire subscription reminder (minutes)',
    ExpireSubscriptionReminderInDays: 'Expire subscription reminder (days)',
    PaymentSubscriptionReminderInDays: 'Payment subscription reminder (days)',
    DiscountIDs: 'Discounts',
    ShouldBeApproved: 'Should be approved',
    IsFixedDuration: 'Fixed duration',
    UserFullName: 'User full name',
    Prices: 'Prices',
    parking_space: 'Parking Space',
    car_number: 'Car number',
    up_to: 'Up to',
    infinite: 'Infinite',
    CarSlots: 'Car slots',
    SubscriptionID: 'Subscription ID',
    Amount: 'Amount',
    Discount: 'Discount',
    Total: 'Total',
    hasUserCompany: 'Public company',
    Permissions: 'Permissions',
    RoleID: 'Role',
    FlowbirdID: 'Flowbird ID',
    MaxParkingHours: 'Max parking hours',
    ParkZoneSchedule: 'Park Zone Schedule',
    AllowFullDayPark: 'Allow full day park',
    SMSCode: 'SMS code',
    SMSNumber: 'SMS number',
    Capacity: 'Capacity',
    ParkZoneID: 'Park zone',
    OldPassword: 'Old password',
    NewPassword: 'New password',
    NewPasswordConfirmation: 'Repeat new password',
    PasswordConfirmation: 'Repeat Password',
    outgoing_sms_provider: 'Outgoing SMS provider',
    general: 'General',
    parking_settings: 'Parking settings',
    Day: 'Day',
    From: 'From',
    To: 'To',
    Category: 'Category',
    EditorType: 'Editor type',
    Translations: 'Translations',
    Number: 'Number',
    TicketNumber: 'Ticket number',
    StoreID: 'Store',
    end_of_day: 'End of day',
    same_time: 'Same time',
    FromDate: 'From date',
    ToDate: 'To date',
    Key: 'Key',
    AdminUserID: 'Inspector name',
    CanceledAdminUserID: 'Cancellation inspector',
    PaymentProviderMethod: 'Payment method',
    FineTypeID: 'Fine type',
    CheckMethod: 'Check method',
    StorePrinterType: 'Store printer',
    PaymentProviderCode: 'Payment provider code',
    InspectionCreatedAt: 'Time of inspection',
    Accuracy: 'GPS Accuracy',
    ParkAreaName: 'Park area name',
    StoreTicketsAndDailyCards: 'Store tickets and daily cards',
    Payments: 'Payments',
    TodayPayments: 'Today payments',
    NextDayPayments: 'Next day payments',
    WhiteLists: 'Whitelists',
    ActiveSubscriptions: 'Active subscriptions',
    InactiveSubscriptions: 'Inactive subscriptions',
    employee_app_cash: 'Cash',
    revenue_agency: 'Revenue agency',
    employee_app_wire: 'Wire',
    Comment: 'Comment',
    PaymentCode: 'Payment method',
    PriceOnField: 'Price on field',
    PriceOnFieldCheckbox: 'Payment on field',
    PaidOnFieldPrinterTextID: 'Printer text on field',
    PaidOnFieldPrinterTextIDCheckbox: 'Has printer text on field',
    MaxPricePerDay: 'Maximum price per day',
    FineTypeIDs: 'Fine types list',
    TotalDays: 'Days',
    TotalHours: 'Hours',
    TotalPrice: 'Total amount',
    fineAlreadyPaidOnlineNote:
      'This fine was already paid online. Complete the release without collecting payment at the desk.',
    CameraID: 'Camera ID',
    CanPark: 'Can park',
    ParkingLotID: 'Parking Lot',
    Trusted: 'Trusted',
    NotTrusted: 'Not Trusted',
    Inspections: 'Inspections',
    Details: 'Details',
    OriginalLicense: 'Original License',
    Photo: 'Photo',
    ParkZoneName: 'Park Zone',
    ParkingLotName: 'Parking Lot',
    ParkingSpaceName: 'Parking Space',
    Location: 'Location',
    OriginalAddress: 'Original Address',
    City: 'City',
    cant_change_moderation_status: 'The inspection is already moderated by another user',
    inspection_image: 'Inspection Image',
    live_camera_image: 'Live Camera Image',
    tyreblock_images: 'Tyrblock Images',
    repo_images: 'Repatration Images',
    image: 'Image',
    unblocked: 'Unblocked',
    release_request_created: 'Release Request Created',
    release_request_taken: 'Release Request Taken',
    calculate_fine_from: 'Calculate Fine From',
    default: 'Default',
    enabled: 'Enabled',
    disabled: 'Disabled',
    printing: 'Printing',
    disableSubscriptionEmail: 'Disable Subscription Email',
    disableSubscriptionSMS: 'Disable Subscription SMS',
    disableSubscriptionApprovedSMS: 'Disable Subscription Approved SMS',
    disableSubscriptionCancelledSMS: 'Disable Subscription Cancelled SMS',
    disableSubscriptionReminderDayBeforeSMS: 'Disable Subscription Reminder Day Before SMS',
    disableSubscriptionReminderSameDaySMS: 'Disable Subscription Reminder Same Day SMS',
    disableBusinessSubscriptionApprovedSMS: 'Disable Business Subscription Approved SMS',
    disableBusinessSubscriptionCancelledSMS: 'Disable Business Subscription Cancelled SMS',
    disableBusinessSubscriptionReminderDayBeforeSMS:
      'Disable Business Subscription Reminder Day Before SMS',
    disableBusinessSubscriptionReminderSameDaySMS:
      'Disable Business Subscription Reminder Same Day SMS',
    useBlockRequestCreatedAtInPaymentErrorMessage:
      'Use block request time in SMS payment error messages',
    paymentAfterExpiredTolerance: 'Allow Payment after expired tolerance',
    CameraModerationUpdated: 'Camera moderation updated',
    AutoInspectorAppModerate: 'Automatically confirm inspections in the inspector app',
    ParentIDs: 'Parents',
    inspection: 'Inspection',
    camera: 'Camera'
  },
  table: {
    ActStatus: 'Objection/Act Status',
    Country: 'Country',
    rows_per_page: 'Rows per page:',
    trusted: 'Trusted',
    business_subscription: 'Business Subscription',
    not_trusted: 'Not Trusted',
    accessible_parking_slot: 'Accessible parking slot',
    paid_parking_space: 'Paid parking space',
    outside_zone: 'Outside of zone',
    rejected: 'Reject',
    invisible: 'Incomplete/Invisible number',
    invalid_incorrect_number: 'Invalid/Incorrect number',
    car_with_special_status: 'Car with special status',
    moving_car: 'Moving car',
    LastUpdate: 'Last location',
    accepted_requests: 'Accepted requests',
    paid_on_field: 'Paid on field',
    repatriated: 'Repatriated',
    Environment: 'Environment',
    Version: 'Version',
    Link: 'Link',
    Download: 'Download',
    Changes: 'Changes',
    AppType: 'App type',
    AppVersion: 'App version',
    Lang: 'Language',
    Key: 'Key',
    Text: 'Text',
    Comment: 'Comment',
    PersonalID: 'Personal ID',
    CarSlots: 'Cars',
    ParkAreas: 'Park areas',
    ticket_machine: 'Ticket machine',
    Source: 'Source',
    TypeName: 'Type name',
    PlanName: 'Plan',
    Active: 'Is active car',
    PaidTo: 'Paid to',
    success: 'Valid',
    failed: 'Invalid',
    RawLicense: 'Необработен рег. номер',
    cash: 'Cash',
    SMSProvider: 'SMS provider',
    FromPhone: 'From phone',
    ToPhone: 'To phone',
    ID: 'ID',
    TicketID: 'Ticket ID',
    Team: 'Team',
    FineTypeName: 'Fine type',
    UserName: 'User name',
    Status: 'Status',
    Name: 'Name',
    Company: 'Company',
    CompanyID: 'Company ID',
    CompanyName: 'Company name',
    Type: 'Type',
    Price: 'Price',
    Percentage: 'Percentage',
    License: 'License',
    City: 'City',
    ParkingID: 'Parking ID',
    Reason: 'Reason',
    ExpireAt: 'Expires at',
    UpdatedAt: 'Updated at',
    CreatedAt: 'Created at',
    Actions: 'Actions',
    Amount: 'Amount',
    pending_review: 'Pending review',
    pending_payment: 'Pending payment',
    declined: 'Declined',
    expired: 'Expired',
    canceled: 'Cancelled',
    canceled_from_far_away: 'Canceled from far away',
    canceled_car_many_times_today: 'Canceled car many times today',
    admin_delete: 'Admin user deleted',
    admin_edit: 'Admin user edited',
    not_paid: 'Not paid',
    Role: 'Role',
    Email: 'Email',
    payment_provider: 'Payment provider',
    payment_count: 'Payment count',
    payment_amount: 'Payment amount',
    parking_daily: 'Daily parking',
    parking_hourly: 'Hourly parking',
    CityName: 'City name',
    FromDate: 'From date',
    ToDate: 'To date',
    IssuedDate: 'Issued date',
    TicketCount: 'Ticket count',
    TicketAmount: 'Ticket amount',
    DailyCardsCount: 'Daily cards count',
    DailyCardsAmount: 'Daily cards amount',
    DailyCardsTicketsTotalAmount: 'Daily cards tickets total amount',
    CanceledTicketCount: 'Cancelled ticket count',
    CanceledTicketAmount: 'Cancelled ticket amount',
    CanceledDailyCardsCount: 'Cancelled daily cards count',
    CanceledDailyCardsAmount: 'Cancelled daily cards amount',
    CanceledDailyCardsTicketsTotalAmount: 'Cancelled daily cards tickets total amount',
    EditorType: 'Editor type',
    TicketNumber: 'Ticket number',
    Store: 'Store',
    Duration: 'Duration',
    StartDate: 'StartDate',
    EndDate: 'End date',
    Category: 'Category',
    TotalAmount: 'Total amount',
    dailyPriceDuration: 'Duration: {0} days, type: {1}',
    Date: 'Date',
    Phone: 'Phone',
    ShortNumber: 'Short number',
    ParkZoneID: 'Park zone',
    ParkZoneName: 'Park zone',
    ZoneName: 'Zone Name',
    data_type: 'Data type',
    data_type_mobile_camera: 'Mobile camera',
    area: 'Area',
    parking_lot: 'Parking lot',
    year: 'Year',
    ParentIncident: 'Parent incident',
    InspectorName: 'Inspector name',
    Location: 'Location',
    Address: 'Address',
    OriginalAddress: 'Original address',
    TyreBlockName: 'Tyre-block name',
    DueDate: 'Due date',
    CanceledAt: 'Canceled at',
    CanceledInspectorName: 'Cancellation inspector',
    CanceledAdminUserID: 'Cancelled by',
    Note: 'Comment',
    Event: 'Event',
    Creator: 'Creator',
    FineHistory: 'Fine History',
    Images: 'Images',
    FineType: 'Fine type',
    PaymentProviderMethod: 'Payment method',
    AdminUserEmail: 'Admin email',
    SubscriptionPlanName: 'Subscription plan',
    SubscriptionOwnerName: 'Subscription owner',
    PaymentMethod: 'Payment method',
    PaymentDue: 'Payment due date',
    CheckMethod: 'Check method',
    Result: 'Result',
    FineStatus: 'Fine status',
    Checks: 'Checks',
    BlockRequest: 'Block request',
    Blocked: 'Blocked',
    NoAction: 'No action',
    Repatration: 'Repatriation',
    Repatriation: 'Repatriation',
    Fine: 'Fine',
    FineDiscount: 'Fine discount',
    Canceled: 'Canceled',
    MovedToRepatration: 'Move to repatration',
    MovedToRepatriation: 'Move to repatriation',
    ReleaseRequest: 'Release request',
    BlockedTime: 'Blocked time',
    ReleasedTime: 'Released time',
    sms: 'SMS',
    checked_car: 'Checked car',
    block_request: 'Block request',
    blocked: 'Blocked',
    no_action: 'No action',
    repatriation_requests: 'Repatration requests',
    custom_fine: 'Custom fine',
    fine_discount: 'Fine discount',
    release_request: 'Release request',
    PaymentProviderCode: 'Payment provider code',
    SMSPhone: 'SMS phone',
    PhoneNumber: 'Phone number',
    ValidUntil: 'Valid until',
    CarID: 'Car ID',
    Method: 'Method',
    Code: 'Code',
    Message: 'Message',
    FirstName: 'First name',
    MiddleName: 'Middle name',
    LastName: 'Last name',
    SubscriptionID: 'Subscription ID',
    fine: 'Fine',
    parking: 'Parking',
    provider: 'Provider',
    total: 'Total',
    Subscription: 'Subscription',
    subscription: 'Subscription',
    ParkingLot: 'Parking Lot',
    LastInspection: 'Last Inspection',
    CameraID: 'Camera ID',
    LastInspectionImage: 'Last Inspection Image',
    valid_checks: 'Valid Checks',
    confirm_edited: 'Confirm Edited',
    tyre_block_requests: 'Tyre Block Requests',
    camera_actions: 'Camera Actions',
    camera_actions_total: 'Total',
    camera_actions_confirmed_edited: 'Corrected',
    camera_actions_confirmed: 'Confirmed',
    camera_actions_rejected: 'Denied',
    camera_actions_expired: 'Expired',
    camera_actions_auto_confirmed: 'Auto Confirmed',
    camera_actions_auto_rejected: 'Auto Rejected',
    camera_actions_pending: 'Pending',
    employee_actions: 'Employee Actions',
    employee_actions_total: 'Total',
    employee_actions_confirmed: 'Confirmed',
    employee_actions_corrected: 'Corrected',
    employee_actions_denied: 'Denied',
    parking_lots: 'Parking lots',
    active_incidents: 'Active Incidents',
    trusted_camera_inspections: 'Trusted Camera Inspections',
    not_trusted_camera_inspections: 'Not Trusted Camera Inspections',
    trusted_mobile_camera_inspections: 'Trusted Mobile Camera Inspections',
    not_trusted_mobile_camera_inspections: 'Not Trusted Mobile Camera Inspections',
    trusted_cameras: 'Trusted Cameras',
    not_trusted_cameras: 'Not Trusted Cameras',
    last: 'Last',
    image_loading_smartalot: 'Loading images from smartAlot',
    wire: 'Card',
    integration: 'integration',
    bank_transfer: 'Bank Transfer',
    IsConverted: 'Is Converted',
    ConvertedAt: 'Converted At',
    mobile_camera: 'Mobile Cameras',
    trusted_mobile_camera: 'Trusted Mobile Cameras',
    not_trusted_mobile_camera: 'Not Trusted Mobile Cameras'
  },
  page: {
    page_info: 'Page Info',
    payments_report: 'Monthly Payments Report',
    post_pay: 'Post pay',
    admin_notifications: 'Admin Notifications',
    apps: 'Mobile applications',
    mobile_apps: 'Mobile Apps',
    car_info: 'Car Info',
    comments: 'Comments',
    street: 'Streets',
    city_payment_provider: 'City payment providers',
    history: 'History',
    mobile_camera_area_information: 'Mobile Camera Area information',
    'camera-management': 'Cameras',
    mobile_camera: 'Mobile Cameras',
    mobile_camera_dashboard: 'Mobile Cameras Dashboard',
    'payments-report': 'Monthly Payments Report',
    login: 'Login',
    forgotten_password: 'Forgot password',
    cities: 'Cities',
    city: 'City',
    store: 'Store',
    store_statistics_by_zone: 'Store statistics (by zone)',
    monthly_statistics: 'Monthly Report - Summary',
    monthly_employees_statistics: 'Monthly Report - Employees',
    inspectorConfig: 'Inspector Config',
    'fine-type': 'Fine type',
    fine_type: 'Fine type',
    discount: 'Subscriptions discount',
    whitelist_car: 'Whitelist car',
    car_tolorance: 'Service vehicles',
    paytrix_config: 'Paytrix config',
    'paytrix-config': 'Paytrix config',
    paytrix_print_config: 'Paytrix print config',
    'paytrix-print-config': 'Paytrix print config',
    subscription_plan: 'Subscription plan',
    'subscription-plan': 'Subscription plan',
    sub_address: 'Subscription Lookup',
    'business-subscription': 'Business subscription',
    subscription: 'Subscription',
    deleted_subscriptions: 'Deleted Subscriptions',
    deleted_business_subscriptions: 'Deleted Business Subscriptions',
    company: 'Company',
    'subscription-payments': 'Subscription payments',
    before: 'Before',
    changes: 'Changes',
    role: 'Roles and Permissions',
    resource: 'Resources',
    permission: 'Permissions',
    'user-management': 'User management',
    customer_users: 'Citizens',
    'park-zone': 'Park zone',
    'park-area': 'Park area',
    'change-password': 'Change password',
    reset_password: 'Reset password',
    payment_statistics: 'Payment statistics',
    administrative_fine_statistics: 'Administrative Fine Statistics',
    payment_details: 'Payment details',
    daily_card: 'Daily cards',
    translations: 'Translations',
    translations_city: 'Translations - cities',
    translations_common: 'Translations - common',
    tickets: 'Tickets',
    sms: 'SMS',
    non_working_days: 'Non-working days',
    incidents_finished: 'Finished incidents',
    incidents_active: 'Active incidents',
    incidents_past: 'Past incidents',
    incidents_repatriation: 'Incidents - repatriation',
    fine: 'Fines',
    payments_fines: 'Payments - Fines',
    payments_subscriptions: 'Payments - Subscriptions',
    payments_parking: 'Payments - Parking',
    cancel_parkings: 'Canceled parkings',
    cancel_parking: 'Canceled parkings',
    inspector_activity: 'Inspector activity',
    tyreblocker_activity: 'Other Employees Activity',
    inspector_activity_details: 'Inspector activity - details',
    tyreblocker_activity_details: 'Tyreblocker activity - details',
    repatriator_activity: 'Repatriator activity',
    repatriator_activity_details: 'Repatriator activity - details',
    camera_activity: 'Camera Activity',
    camera_activity_details: 'Camera Activity - details',
    camera_incidents_active: 'Camera Active Incidents',
    select_image: 'Please select the image',
    no_checks_for_car: 'No checks for this car found for today',
    camera_activity_actions: 'Camera Activity Actions',
    inspection_reviews: 'Inspection Reviews',
    super_statistics: 'Areas statistics'
  },
  router: {
    '/citizen-map-drawing': 'Citizen map drawings',
    '/incidents/blocking-request-history': 'Blocking Request History',
    '/': 'home',
    '/statistics': 'Statistics',
    '/statistics/administrative-fines': 'Administrative Fine Statistics',
    '/apps': 'mobile applications',
    '/mobile-apps': 'mobile apps',
    '/city': 'city',
    '/company': 'company',
    '/store': 'store',
    '/fine-type': 'fine type',
    '/discount': 'subscriptions discount',
    '/whitelist-car': 'whitelist car',
    '/car-tolorance': 'service vehicles',
    '/subscription': 'subscription',
    '/business-subscription': 'business subscription',
    '/delete-subscription': 'delete subscription',
    '/deleted-subscriptions': 'deleted subscriptions',
    '/deleted-business-subscriptions': 'deleted business subscriptions',
    '/subscription-plan': 'subscription plan',
    '/sub-address': 'subscription lookup',
    '/street': 'streets',
    '/subscription/payments': 'subscription payments',
    '/role': 'role and permissions',
    '/user-management': 'user management',
    '/park-zone': 'park zone',
    '/park-area': 'park area',
    '/admin-notifications': 'admin notifications',
    '/mc-park-area': 'mobile camera area',
    '/change-password': 'change password',
    '/statistics/payments': 'payment statistics',
    '/statistics/payments/details': 'details',
    '/store-statistics': 'store statistics',
    '/store-statistics-by-zone': 'store statistics by zone',
    '/camera-management': 'camera management',
    '/mobile-camera-dashboard': 'mobile cameras dashboard',
    '/translations-city': 'translations - cities',
    '/translations-common': 'translations - common',
    '/daily-card': 'daily cards',
    '/tickets': 'tickets',
    '/sms': 'sms',
    '/non-working-days': 'non-working days',
    '/incidents/active': 'active incidents',
    '/inspections/reviews': 'inspections reviews',
    '/incidents/finished': 'finished incidents',
    '/incidents/cameras': 'camera incidents',
    '/incidents/past': 'past incidents',
    '/incidents/repatriation': 'incidents - repatriation',
    '/fines': 'fines',
    '/mvr-fines': 'MVR fines',
    '/payments/fines': 'payments - fines',
    '/payments/parking': 'payments - parking',
    '/cancel-parkings': 'cancel parkings',
    '/payments/subscriptions': 'payments - subscriptions',
    '/reports/inspector-activity': 'inspector activity',
    '/reports/tyreblocker-activity': 'tyreblocker activity',
    '/comments': 'comments',
    '/city-payment-provider': 'city payment providers',
    '/car-info': 'Car Info',
    '/repatriation-incidents/active': 'repatriation - active',
    '/repatriation-incidents/finished': 'repatriation - finished',
    '/repatriation-incidents/past': 'repatriation - past',
    '/reports/repatriator-activity': 'repatriator activity',
    '/reports/camera-activity': 'camera activity',
    '/reports/camera-activity-actions': 'camera activity actions',
    '/employee-reports/monthly-employees': 'Monthly Report (Employees)',
    '/payments-report': 'Monthly Payment Report',
    '/post-pay': 'Post Pay',
    '/super-statistics': 'Areas statistics'
  },
  months: {
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec'
  },
  day: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },
  warning: {
    cancelLocationNear:
      'The location of the inspection and the location of the cancellation are in close proximity to each other',
    approveSubscriptionTitle: 'Wait! Are you sure you want to proceed?',
    cancelSubscriptionTitle: 'Wait! Are you sure you want to proceed?',
    reverseCancelSubscriptionTitle: 'Wait! Are you sure you want to proceed?',
    confirmDeleteTitle: 'Wait! Are you sure you want to proceed?',
    cancelPaymentTitle: 'Wait! Are you sure you want to proceed?',
    approveSubscriptionDescription: 'Please confirm in order to proceed.',
    cancelPaymentDescription: 'Please confirm in order to proceed.',
    cancelSubscriptionDescription: 'Please confirm in order to proceed.',
    cancelSubscriptionMessage: 'Please confirm in order to proceed.',
    subscriptionAddressMatch:
      'Warning: found {count} registered subscriptions for address: {address}.',
    subscriptionAddressConfirmTitle: 'Address match found',
    subscriptionAddressConfirmDescription:
      'There are existing subscriptions for this address. Please confirm if you still want to save this subscription.',
    subscriptionAddressConfirmDetailedSummary:
      'There are {count} subscriptions on {street}, No. {number}, Entrance {entrance}, Apt. {apartment}.',
    subscriptionAddressComparisonHint:
      'Red cells exactly match the current input. Green cells are different.',
    subscriptionAddressLookupHint:
      'No exact match is required here. The table shows all known combinations for this street/type, so you can see how this address was entered. Green cells match your filters.',
    reverseCancelSubscriptionDescription:
      'By doing that you will also reverse the cancelled payment for {0}.',
    reverseCancelSubscriptionMessage: 'Please confirm in order to proceed.',
    confirmDeleteDescription: 'There is no way to revert this action once it is completed.',
    paymentSummaryTitle: 'Details summary:',
    401: 'Session expired. Please login again',
    no_data: 'No available data',
    no_data_for_period: 'No available data for selected period',
    payFineTitle: 'Pay fine?',
    payFineDescription: 'Please confirm in order to proceed',
    reversePayFineTitle: 'Reverse payment?',
    reversePayFineDescription: 'Please confirm in order to proceed',
    incidentConfirmReleaseTitle: 'Create release request',
    incidentConfirmReleaseDescription: 'Please confirm in order to proceed',
    incidentCancelTitle: 'Cancel incident',
    incidentCancelDescription: 'Please confirm in order to proceed',
    repatriationConfirmCancelTitle: 'Cancel repatriation request',
    repatriationConfirmCancelDescription: 'Please confirm in order to proceed',
    contact_sms_operator_reminder:
      'You need to contact the SMS operator to inform them about the non-working days.',
    administrativeFineUserReminderTitle: 'Reminder',
    administrativeFineUserReminderMessage: "Don't forget to add this fine to the users.",
    parkAreaSubscriptionPlanReminderTitle: 'Reminder',
    parkAreaSubscriptionPlanReminderMessage:
      "Don't forget to add this park area to the relevant subscription plans.",
    duration_already_exists:
      'Daily card with such parameters already exists. Please remove the old one first before you add a new one.',
    confirmInspectionTitle: 'Wait! Are you sure you want to proceed?',
    confirmInspectionDescription: 'Please confirm in order to proceed.',
    rejectInspectionTitle: 'Wait! Are you sure you want to proceed?',
    rejectInspectionDescription: 'Please confirm in order to proceed.',
    noInspectionForCamera: 'No Inspection For Camera',
    InspectionImageError_timeout: 'No response from SmartALot (timeout)',
    InspectionImageError_api: 'Invalid response from SmartALot',
    min3chars: 'Please enter at least 3 characters.',
    select_park_area: 'Please select park zone first to draw',
    outside_bounds: 'Outside of allowed bounds!'
  },
  tableRows: {
    country_unassigned: 'Unassigned (legacy upload)',
    minutes: 'minutes',
    day: 'day',
    days: 'days',
    translated: 'Translated',
    app_manual: 'Manual',
    app_ocr: 'Image',
    active: 'Active',
    inactive: 'Inactive',
    pending_payment: 'Pending payment',
    pending_review: 'Pending review',
    declined: 'Declined',
    expired: 'Expired',
    canceled: 'Cancelled',
    canceled_from_far_away: 'Canceled from far away',
    canceled_car_many_times_today: 'Canceled car many times today',
    electric_car: 'Electric car',
    municipal_car: 'Municipal car',
    other: 'Other',
    repatriation: 'Repatriation',
    tire_block: 'Tire block',
    administrative: 'Administrative',
    not_paid: 'Not paid',
    paid: 'Paid',
    discount: 'Discount',
    payment: 'Payment',
    durationHoursAndMinutes: '{0} hours and {1} minutes',
    durationHours: '{0} hours',
    durationMinutes: '{0} minutes',
    paid_with_cash: 'Paid with cash',
    paid_with_wire: 'Paid with card',
    cash: 'Paid with cash',
    wire: 'Paid with card',
    bank_transfer: 'Bank Transfer',
    mobile_app: 'Mobile app',
    mobzzo_mobile: 'Mobzzo Mobile',
    inspector_app: 'Inspector app',
    customer_app: 'Customer app',
    store_app: 'Store app'
  },
  select: {
    active: 'Active',
    inactive: 'Inactive',
    pending_review: 'Pending review',
    pending_payment: 'Pending payment',
    declined: 'Declined',
    expired: 'Expired',
    canceled: 'Cancelled',
    not_paid: 'Not paid',
    paid: 'Paid',
    electric_car: 'Electric car',
    municipal_car: 'Municipal car',
    other: 'Other',
    repatriation: 'Repatriation',
    tire_block: 'Tire block',
    administrative: 'Administrative'
  },
  customer_user: {
    search_hint: 'Search by ID, email, phone or name',
    details_title: 'Citizen details',
    access_token_title: 'Citizen access token',
    access_token_description:
      'Copy this token for {user}, then paste it in the hidden login dialog in the Citizen app.',
    access_token: 'Access token',
    id: 'ID',
    status: 'Status',
    email: 'Email',
    mobile: 'Mobile',
    name: 'Name',
    source: 'Source',
    google_id: 'Google ID',
    facebook_id: 'Facebook ID',
    allow_notifications: 'Allow notifications',
    last_active_at: 'Last active at',
    created_at: 'Created at',
    status_new: 'New',
    status_confirmed: 'Confirmed',
    status_blocked: 'Blocked'
  },
  notification: {
    subscription_document_failed:
      'Document generation failed. Please check the template and subscription data.',
    document_download_failed: 'Document download failed. Refresh the page and try again.',
    500: 'Oops, something went wrong',
    success_approve_subscription: 'Subscription has been successfully approved',
    success_cancel_subscription: 'Subscription has been successfully cancelled',
    success_cancel_fine: 'Fine has been successfully cancelled',
    success_cancel_payment: 'Payment has been successfully cancelled',
    success_password_reset_request: 'Email with password reset link has been sent to your email',
    success: 'Success',
    success_payment: 'The payment is successful',
    success_export: 'Success! Please check your email.',
    fail_export: 'Oops, something went wrong! The export was not successful.',
    subscription_payment_invalid_status: 'Cannot display payments for this subscription status',
    inspection_confirmed: 'Inspection Confirmed',
    inspection_rejected: 'Inspection Rejected',
    access_token_copied: 'Access token copied',
    access_token_copy_failed: 'The access token could not be copied'
  },
  tooltip: {
    daily_card_end_of_day_info:
      'Valid until the end of the parking zone’s working hours on the last working day of the selected duration. Non-working days are skipped.',
    daily_card_same_time_info:
      'Valid until the same starting time after the selected number of working days. Non-working days are skipped.',
    delete_duration: 'Delete duration',
    AllowProrateDuration: 'Allow prorate duration',
    total_amount: 'Total amount',
    service: 'Service',
    printer_formatting_help: 'Printer formatting help',
    printer_commands: {
      reset: 'Reset to default settings.',
      line_break: 'Line break. Equivalent of new line.',
      bold: 'Set or clear bold font style.',
      underline: 'Set or clear underline font style.',
      italic: 'Set or clear italic font style.',
      small: 'Set or clear small font style.',
      high: 'Set or clear high font style.',
      wide: 'Set or clear wide font style.',
      align_left: 'Aligns text to the left paper edge.',
      align_center: 'Aligns text to the center of paper.',
      align_right: 'Aligns text to the right paper edge.'
    }
  },
  administrativeFineStatistics: {
    issue_date_from: 'Issue Date From',
    issue_date_to: 'Issue Date To',
    invalid_date_range: 'Issue Date From cannot be later than Issue Date To.',
    empty: 'No administrative fines were issued during the selected period.',
    loading: 'Loading administrative fine statistics…',
    load_error: 'The statistics could not be loaded. Please try again.',
    try_again: 'Try Again',
    total_discount_amount: 'Total Discount Amount',
    applied_discount: 'Applied Discount',
    subtitle:
      'Overview of administrative fines issued within the selected period, their payment status, applied discounts, and paid amounts.',
    summary: 'Summary',
    detailed_statistics: 'Detailed Statistics by Violation Type',
    total_issued_fines: 'Total Issued Fines',
    total_paid_fines: 'Total Paid Fines',
    total_unpaid_fines: 'Total Unpaid Fines',
    total_value_issued_fines: 'Total Value of Issued Fines',
    total_collected_revenue: 'Total Amount Paid',
    outstanding_amount: 'Total Outstanding Amount',
    article: 'Article',
    article_description: 'Article Description',
    issued_fines: 'Issued Fines',
    paid_fines: 'Paid Fines',
    unpaid_fines: 'Unpaid Fines',
    issued_amount: 'Issued Amount',
    collected_amount: 'Collected Amount',
    total: 'Total',
    article_label: 'Article {number}'
  },
  chart: {
    pending_confirmation: 'Pending Confirmation',
    finalized: 'Finalized',
    failed: 'Failed',
    success: 'Success',
    fines: 'Fines',
    canceled_by_employee: 'Canceled by employee',
    automatical_canceled: 'Automatical canceled',
    whitelisted_cars: 'Whitelisted cars',
    monthly_incidents: 'Monthly incidents chart',
    daily_incidents: 'Daily incidents chart',
    hourly_incidents: 'Hourly incidents chart',
    incidents_count: 'Incidents (count)',
    occupancy: 'Occupancy',
    occupancy_percentage: 'Occupancy (%)',
    monthly_occupancy: 'Monthly occupancy chart',
    daily_occupancy: 'Daily occupancy chart',
    hourly_occupancy: 'Hourly occupancy chart',
    payment_statistics: 'Payment statistics',
    short_term_payments: 'Short-term payments',
    subscriptions: 'Subscriptions',
    monthly_payment: 'Monthly payment chart',
    daily_payment: 'Daily payment chart',
    hourly_payment: 'Hourly payment chart',
    payment_percentage: 'Payment (% of capacity)',
    payment_count: 'Payment (count)',
    subscription_breakdown: 'Subscription breakdown',
    fine: 'Fine',
    parking: 'Parking',
    parking_daily: 'Daily Parking',
    parking_hourly: 'Hourly Parking',
    blocked: 'Blocked',
    business_subscription: 'Business Subscription',
    in_tolerance: 'In Tolerance',
    block_request_created: 'Expired Tolerance, Waiting for Tyreblock',
    block_request_taken: 'Tyreblock Request Taken',
    expired_tolerance_waiting_for_tyreblock: 'Expired Tolerance, Waiting for Tyreblock',
    request_for_release: 'Request for Release',
    release_request_created: 'Release Request Created',
    taken_request_for_release: 'Taken Request for Release',
    release_request_taken: 'Release Request Taken',
    block_request_initialized: 'Block Request Initialized',
    expired: 'Expired',
    unblocked: 'Unblocked',
    unblocked_no_payment: 'Unblocked no payment',
    subscription: 'Subscription',
    repatriation_request_created: 'Repatriation Request Created',
    repatriation_request_taken: 'Repatriation Request Taken',
    repatriation_on_the_way: 'Repatriation on the Way',
    repatriation_at_parking: 'Repatriation at Parking',
    repatriation_released: 'Repatriation Released',
    valid_check_with_payment: 'Valid Check With Payment',
    in_tolerance_without_payment: 'In Tolerance Without Payment',
    pending: 'Pending',
    confirmed: 'Confirmed',
    auto_confirmed: 'Auto Confirmed',
    rejected: 'Rejected',
    auto_rejected: 'Auto Rejected',
    has_payment: 'Has Payment',
    employees_total: 'Total Employees',
    employees_inspectors: 'Inspectors',
    employees_tyreblockers: 'Tyreblockers',
    employees_repatriators: 'Repatriators',
    employees_cameras: 'Cameras',
    actions_inspections: 'Inspections',
    actions_inspections_camera: 'Inspections by Cameras',
    actions_tyre_blocks_requested: 'Tyreblock Requests',
    actions_tyre_blocks_executed: 'Tyreblocks Executed',
    actions_tyre_blocks_requested_camera: 'Tyreblock Requests (Cameras)',
    actions_tyre_blocks_executed_camera: 'Tyreblocks Executed (Cameras)',
    actions_repatriations_requested: 'Repatriation Requests',
    actions_repatriations_executed: 'Repatriations Executed',
    actions_repatriations_requested_camera: 'Repatriation Requests (Cameras)',
    actions_repatriations_executed_camera: 'Repatriations Executed (Cameras)',
    payment_parking: 'Parking',
    payment_fines: 'Fines',
    payment_subscriptions: 'Subscriptions',
    table_section_personnel: 'Personnel',
    table_section_activities: 'Activities',
    table_section_revenue: 'Revenue',
    chart_title_personnel: 'Employees',
    chart_title_activities: 'Activities',
    employees_inspectors_total: 'Total Inspectors',
    employees_inspectors_inspections: 'Inspections',
    employees_inspectors_requests: 'Requests',
    employees_inspectors_fines: 'Fines',
    employees_inspectors_no_actions: 'No Actions',
    employees_tyre_blockers_total: 'Total Tyreblockers',
    employees_tyre_blockers_blocked: 'Blocked',
    employees_tyre_blockers_canceled: 'Canceled',
    employees_repatriators_total: 'Total Repatriators',
    employees_repatriators_blocked: 'Blocked',
    employees_repatriators_canceled: 'Canceled',
    compare_inspectors_inspections: 'Inspections',
    compare_inspectors_requests: 'Requests',
    compare_inspectors_fines: 'Fines',
    compare_inspectors_no_actions: 'No Actions',
    compare_tyre_blockers_blocked: 'Blocked',
    compare_tyre_blockers_canceled: 'Canceled',
    compare_repatriators_blocked: 'Blocked',
    compare_repatriators_canceled: 'Canceled',
    active: 'Active',
    ready: 'Ready',
    canceled: 'Canceled',
    inactive: 'Inactive',
    pending_payment: 'Pending Payment',
    pending_review: 'Pending Review',
    no_checks: 'No Checked Cars',
    PrintImages: 'Print Images',
    generated: 'Generated',
    sent_to_mateus: 'Sent to Mateus',
    sent: 'Sent physically',
    received: 'Received',
    not_received: 'Not received',
    resent: 'Resent',
    received_second_try: 'Received on second try',
    not_received_second_try: 'Not received on second try',
    fine_cancelled: 'Fine Cancelled',
    fine_paid: 'Fine Paid'
  },
  label: {
    development: 'dev',
    production: 'prod',
    Inspector: 'Employees',
    InspectorNoPrinter: 'Employees - no printer',
    Stores: 'Stores',
    confirmPayment: 'Please confirm payment?',
    welcome: 'Welcome to {0}',
    mobzzo_admin_panel: 'Admin panel dashboard',
    dashboard_message: 'The best parking solutions to ensure efficient parking management.',
    reject_reason: 'Reject reason'
  },
  MonthlyEmployeesStatistics: {
    inspectors: 'Inspectors',
    employee: 'Employee',
    compare: 'Compare',
    P: 'P',
    Z: 'Z',
    G: 'G',
    BD: 'BD',
    total_employees: 'Total Employees',
    total: 'Total',
    blocked: 'Blocked',
    canceled: 'Canceled',
    auto_canceled: 'Auto Canceled',
    repatriation: 'Repatriation',
    tyre_blockers: 'Tyre Blockers'
  }
}
